import { SERVICE_TYPE, SERVICE_STATUS } from './../constants/linkedservice.const'
import moment from 'moment'

export const formatTableDataLinkedService = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    id: item.id,
    code: item.id,
    type: [{
      label: SERVICE_TYPE.find(type => type.value === item.type)?.label || '--',
      type: 'info',
    }],
    status: [{
      label: SERVICE_STATUS.find(status => status.value === item.status)?.label || '--',
      type: SERVICE_STATUS.find(status => status.value === item.status)?.color || 'info',
    }],
    logo: item.logo?.url?.thumbnail || '',
    name: item.name,
    representative_name: item.representative_name,
    phone: item.phone,
    email: item.email,
    address: item.address,
    campaign: item.campaign_latest?.package || '--',
    expired_at: item?.campaign_latest?.expired_at || '',
    total_click: item.campaign_latest?.total_click || '--',
    total_approach: item.campaign_latest?.total_approach || '--',
  }))
}

const STATUS = {
  NOT_STARTED: 'not_started',
  RUNNING: 'running',
  ENDED: 'ended',
  EXPIRING: 'expired',
}

const STATUS_OPTIONS = [
  { value: STATUS.NOT_STARTED, label: 'Chưa bắt đầu', color: 'info' },
  { value: STATUS.RUNNING, label: 'Đang chạy', color: 'success' },
  { value: STATUS.ENDED, label: 'Kết thúc', color: 'warning' },
  { value: STATUS.EXPIRING, label: 'Hết hạn', color: 'danger' },
]

export const formatTableDataCampaign = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    id: item.id,
    code: item.id,
    status: [{
      label: STATUS_OPTIONS.find(status => status.value === item.status)?.label || '--',
      type: STATUS_OPTIONS.find(status => status.value === item.status)?.color || 'info',
    }],
    activated_at: item.activated_at ? moment(item.activated_at).format('YYYY-MM-DD 00:00:00') : '',
    expired_at: item.expired_at ? moment(item.expired_at).format('YYYY-MM-DD 23:59:59') : '--',
  }))
}
